<template>
  <div class="control-alarmlist" :class="{ 'control-list-show': isShow }" >
    <div class="control-list-panel flex-valign">
      <div class="list-search flex-between valign-center" style="background-color: #909399;">
        <!-- 选择子系统 -->
        <div class="text-center flex-auto rel">
          <!-- 主机名称收索 -->
          <div class="valign-center" style="width: 325px;">
            <div class="mr5 ell" style="margin-left: 10px">
              <span>{{ subsystemText }}</span>
            </div>
            <span
              style="margin-right: 5px"
              @click.stop="resetBtn"
              title="清除"
              v-if="subsystemText.length > 4"
              ><i class="iconfont1 ioc-Error point-icon"></i
            ></span>
            <span
              :class="[
                'iconfont-lunan icon-lunan-xiaosanjiaodown',
                statusExpandType ? 'icon-transform' : '',
                'select-arrow'
              ]"
              @click.stop="
                statusExpandType = !statusExpandType;
                typeExpandType = searchFormShow = false;
              "
            ></span>
          </div>
          <div :class="['type-select', statusExpandType ? 'expand' : '']">
            <el-scrollbar class="select-area flex-valign">
              <el-input placeholder="请输入搜索关键字"
                        prefix-icon="el-icon-search"
                        v-model="searchText"
                        style="width:95%"
                        @click.stop.native="stopPropagation"
                        clearable>
              </el-input>
              <el-cascader-panel
                v-model="searchForm.zjdeviceName"
                style="text-align: left; margin-bottom: 10px"
                ref="cascaderPanel"
                :options="restaurants"
                @change="cascaderChange"
                @expand-change="expandChange"
                @active-item-change="itemChange"
                :props="cascaderProps2"
              ></el-cascader-panel>

              <!-- <el-cascader-panel v-model="cascaderValue"
                                 ref="cascaderPanel"
                                 :options="cascaderOptions"
                                 @change="cascaderChange"
                                 @expand-change="expandChange"
                                 @active-item-change="itemChange"
                                 :props="cascaderProps"></el-cascader-panel> -->
            </el-scrollbar>
          </div>
        </div>

        <div
          class="point-icon iconfont-lunan icon-lunan-gengduoda ml10"
          @click.stop="
            () => {
              searchFormShow = !searchFormShow;
              statusExpandType = typeExpandType = false;
            }
          "
        ></div>
        <el-collapse-transition>
          <div
            class="list-search_form"
            v-if="searchFormShow"
            @click.stop="stopPropagation"
          >
            <el-form :model="searchForm" label-width="100px">
              <el-form-item label="告警名称：">
                <el-input
                  v-model="searchForm.alarmName"
                  @change="handleChanName"
                  @click.stop.native="stopPropagation"
                  placeholder="请输入告警名称"
                  class=""
                ></el-input>
              </el-form-item>
              <el-form-item label="时间范围：">
                <el-date-picker
                  style="width: 100%"
                  v-model="searchForm.alarmTime"
                  type="datetimerange"
                  :clearable="false"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="handleChangeTime"
                  :start-placeholder="$t('realTimeAlarm.placeholder.startTime')"
                  :end-placeholder="$t('realTimeAlarm.placeholder.endTime')"
                >
                </el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="主机名称：">
                <el-autocomplete class="inline-input"
                                 clearable
                                 v-model="searchForm.zjdeviceName"
                                 :fetch-suggestions="querySearch"
                                 placeholder="请输入主机名称"
                                 @select="handleSelect"></el-autocomplete>
              </el-form-item> -->
              <!-- <el-form-item label="主机编号：">
                <el-autocomplete
                  class="inline-input"
                  clearable
                  style="width: 100%"
                  v-model="searchForm.thirdAlarmDevId"
                  :fetch-suggestions="querySearch2"
                  placeholder="请输入主机编号"
                  @select="handleSelect2"
                ></el-autocomplete>
              </el-form-item> -->
              <el-form-item label-width="0px" class="text-right">
                <el-button @click="reset" type="info">重置</el-button>
                <el-button type="primary" @click="queryList">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { Dic } from "$utils";
import { api } from "../api";
export default {
  name: "control-left",
  components: {},
  props: {},
  data() {
    return {
      isShow: true,
      expandType: true,
      searchForm: {
        controlType: 0,
        status: 0,
        alarmTime: [],
        controlName: "",
        alarmName: "",
        zjdeviceName: [],
        thirdAlarmDevId: ""
      },
      searchFormShow: false,
      controlTypeList: [],
      typeMap: {},
      typeList: {},
      typeExpandType: false,
      statusList: [],
      statusExpandType: false,
      status: 1,
      //所有告警类型字典
      alarmTypesDic: [],
      statusMap: {},
      cascaderValue: [],
      cascaderProps2: {
        children: "children",
        label: "value",
        value: "value",
        expandTrigger: "hover"
      },
      cascaderProps: {
        children: "children",
        label: "name",
        value: "id",
        expandTrigger: "hover"
      },
      subsystemList: [], //子系统列表
      subsystemText: "主机名称", // '消防子系统',
      subsystemTypeList: [], //子系统下的类型列表
      cascaderOptions: [],
      restaurants: [],
      bfRestaurants: [],
      restaurants2: [],
      searchText: "",
      nameArr: {}
    };
  },
  watch: {
    searchText(value) {
      if (value) {
        let filterList = this.restaurants.filter((el) => {
          if (el.value.indexOf(value) !== -1) {
            return el;
          }
        });
        this.restaurants = [...filterList];
      } else {
        this.restaurants = [...this.bfRestaurants];
      }
    }
  },
  created() {
    this.nameArr = {};
    for (var i = 65; i < 91; i++) {
      //  this.nameArr.push(String.fromCharCode(i));
      this.nameArr[String.fromCharCode(i) + "区"] = [];
    }
  },
  mounted() {
    // let list = Dic.find("SENU004")
    // this.getAlarmTypes(list)
    this.getAlarmTypeAndSubsystem();
    this.queryFireDevice();
    document.addEventListener("click", this.domClick);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.domClick);
  },
  methods: {
    resetBtn() {
      this.subsystemText = "主机名称";
      this.searchForm.zjdeviceName = [];
      this.$emit("handleSearchBtn2", {
        deviceName: "全部",
        id: "",
        deviceId: ""
      });
    },
    queryFireDevice() {
      this.$fetch(api.cms.queryFireDevice, {
        deviceMarkList: ["27", "28", "29"],
        pageNum: 1,
        pageSize: 10000,
        systemId: "200000024"
      }).then((response) => {
        if (response.success) {
          // 设备名称
          // this.restaurants = [{
          //   value: '全部',
          //   id: '',
          // }].concat(response.returnObj.list.map(el => {
          //   return {
          //     value: el.thirdDeviceName + ' ( ' + el.thirdDeviceId + ' )',
          //     id: el.thirdDeviceId,
          //     deviceID: el.deviceID
          //   }
          // })
          // ).concat([{
          //   value:"电气火灾",
          //   id:'-1'
          // }]);
          let newArr = [];
          let otherArr = [];
          response.returnObj.list.forEach((el, index) => {
            newArr.push({
              value: el.thirdDeviceName ,//+ " ( " + el.thirdDeviceId + " )",
              id: el.thirdDeviceId,
              deviceID: el.deviceID
            });
            // let nameId = el.thirdDeviceName.slice(0, 2);
            // if (this.nameArr[nameId]) {
            //   this.nameArr[nameId].push({
            //     value: el.thirdDeviceName + " ( " + el.thirdDeviceId + " )",
            //     id: el.thirdDeviceId,
            //     deviceID: el.deviceID
            //   });
            // } else {
            //   otherArr.push({
            //     value: el.thirdDeviceName + " ( " + el.thirdDeviceId + " )",
            //     id: el.thirdDeviceId,
            //     deviceID: el.deviceID
            //   });
            // }
          });

          // console.log(this.nameArr)
          // for (let key in this.nameArr) {
          //   if (this.nameArr[key].length > 0) {
          //     newArr.push({
          //       value: key,
          //       label: key,
          //       children: this.nameArr[key]
          //     });
          //   }
          // }
          // otherArr.push({
          //   value: "电气火灾",
          //   id: "-1"
          // });
          // newArr.push({
          //   value: "其他",
          //   label: "其他",
          //   children: otherArr
          // });
          // console.log(newArr)
          this.restaurants = JSON.parse(JSON.stringify(newArr));
          this.bfRestaurants = [...this.restaurants];
          this.restaurants2 = response.returnObj.list.map((el) => {
            return {
              name: el.thirdDeviceName + " ( " + el.thirdDeviceId + " )",
              value: el.thirdDeviceId
            };
          });
        } else {
          // this.$message.error(response.msgContent || "获取设备详情失败");
        }
      });
    },
    emitChange(item) {
      console.log(item);
    },
    handleSelect(item) {
      this.emitChange(item);
    },
    handleSelect2(item) {
      this.emitChange(item);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    querySearch2(queryString, cb) {
      var restaurants = this.restaurants2;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    cascaderChange(value) {
      console.log(value)
      console.log( this.$refs.cascaderPanel.getCheckedNodes()[0])
      // console.log(this.$refs.cascaderPanel.getCheckedNodes()[0])
      // console.log('--级联下拉change事件---', value);
      // this.$parent.handTypeLever(value[0], value[1]);
      // this.subsystemList = this.$refs.cascaderPanel.getCheckedNodes()
      // console.log(this.$refs.cascaderPanel.getCheckedNodes()[0].data.deviceID)
      // this.subsystemText = this.subsystemList[0].pathLabels[0] + ' / ' + this.subsystemList[0].pathLabels[1]
      this.subsystemText = " 主机名称 / " + value[0];
      let params = {
        deviceName: this.searchForm.zjdeviceName[0],
        id: this.$refs.cascaderPanel.getCheckedNodes()[0].data.id,
        deviceId: this.$refs.cascaderPanel.getCheckedNodes()[0].data.deviceID
      };
      this.$emit("handleSearchBtn2", params);
    },
    expandChange(value) {
      // console.log('=====展开组成的数组值=====', value);
    },
    itemChange(value) {
      // console.log('=====单项点击值=====', value);
    },
    //获取工作组树列表
    getAlarmTypeAndSubsystem() {
      const self = this;
      this.$fetch(api.alarm.getAlarmTypeAndSubsystem, {}).then((response) => {
        // 消防告警页面只展示消防子系统
        response.returnObj.forEach((item, index) => {
          if (item.id === "4") {
            self.cascaderOptions.push(item);
          }
        });
        // 因消防告警页面只有消防子系统页面与实时告警有区别不需加上全部选项
        // self.cascaderOptions = [{ id: "-1", name: "全部", children: [] }].concat(Object.freeze(fireOptions));

        self.cascaderOptions.forEach((item, index) => {
          if (item.id === "4") {
            item.children.unshift({ id: "", name: "全部" });
          }
        });
        // self.cascaderOptions.map(item => {
        //   if (item.children.length == 0) {
        //     item.children = undefined;
        //   }
        // })
      });
    },
    typeClick() {
      this.typeExpandType = !this.typeExpandType;
      this.statusExpandType = this.searchFormShow = false;
    },
    handleChangeTime(val) {
      this.$emit("handleChangeTime", val);
    },
    handleChanName(val) {
      this.$emit("handleChangeDeviceName", val);
    },
    showPlanListPanel() {
      this.isShow = !this.isShow;
    },
    createTask() {
      this.$emit("createTask");
    },
    stopPropagation() {
      // 阻止冒泡
    },
    domClick() {
      this.typeExpandType = false;
      this.statusExpandType = false;
      this.searchFormShow = false;
    },
    queryList() {
      let params = {
        alarmTime: this.searchForm.alarmTime,
        alarmName: this.searchForm.alarmName,
        thirdAlarmDevId: this.searchForm.thirdAlarmDevId
        // deviceName: this.searchForm.zjdeviceName,
      };
      this.$emit("handleSearchBtn2", params);
    },
    reset() {
      this.$emit("handleRestBtn");
      this.searchForm = {
        controlType: 0,
        status: 0,
        alarmTime: ""
        // alarmName: "",
      };
    }
  }
};
</script>
<style lang="scss">
@import "../style/control-left.scss";
</style>
